import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/dashboard', [
    {
      path: '',
      name: 'dashboard',
      beforeEnter(to, from, next) {
        let redirect: string | undefined = undefined;
        if (router.app.$session.role) {
          if (router.app.$session.role.type === 'serviceprovider') {
            redirect = 'dashboard-service-provider';
          } else {
            redirect = 'dashboard-oversight-organization';
          }
        }
        if (redirect) {
          if (redirect === from.name) {
            // this is needed as afterEach() will not be called unless the route actually changes causing an infinite spinner
            router.app.$loading(false);
          }
          next({ name: redirect });
        } else {
          next(false);
        }
      },
    },
    {
      path: '/oversight_organization',
      name: 'dashboard-oversight-organization',
      component: () => import('@/views/dashboard/OversightDashboard.vue'),
    },
    {
      path: '/service_provider',
      name: 'dashboard-service-provider',
      component: () => import('@/views/dashboard/ServiceProviderDashboard.vue'),
    },
  ]);
};
